<script>
  import { format } from 'svelte-i18n';
  import { Alert } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { ShowMore } from '@client/components/show-more';

  import SyncProgress from './sync-progress.svelte';

  export let failures = 0;
  export let results = [];
  export let successes = 0;
  export let syncing = false;
  export let total = 0;
  export let type = 'USERS';

  $: current = results.length + 1;
  $: syncedUsers = results?.filter((user) => user.success);
  $: failedUsers = results?.filter((user) => !user.success);
</script>

{#if syncing}
  <SyncProgress {current} {total} {type} />
{:else}
  {#if successes}
    <Alert color="success" class="mb-0">
      <h5 class="alert-heading">
        <Icon name="check-circle" />
        {$format(`label.SYNC_SUCCESSES_${type}`, {
          values: { n: successes }
        })}
      </h5>
      <ShowMore class="text-reset">
        <ul class="mt-2 mb-0">
          {#each syncedUsers as user}
            <li>{user.name}</li>
          {/each}
        </ul>
      </ShowMore>
    </Alert>
  {/if}
  {#if failures}
    <Alert color="danger" class="mt-3 mb-0">
      <h5 class="alert-heading">
        <Icon name="alert-triangle" />
        {$format(`label.SYNC_FAILURES_${type}`, {
          values: { n: failures }
        })}
      </h5>
      <ShowMore class="text-reset">
        <ul class="mt-2 mb-0">
          {#each failedUsers as user}
            <li>{user.name}</li>
          {/each}
        </ul>
      </ShowMore>
    </Alert>
  {/if}
{/if}
